/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class HttpService {

  get apiUrlAdmin(): string {
    return environment.apiUrlAdmin;
  }

  get apiUrlApp(): string {
    return environment.apiUrlAdmin;
  }
  constructor(private http: HttpClient) {}

  getAdmin(endpoint: string, options?): Observable<any> {
    return this.http.get(`${this.apiUrlAdmin}/${endpoint}`, options);
  }

  postAdmin(endpoint: string, data, options?): Observable<any> {
    return this.http.post(`${this.apiUrlAdmin}/${endpoint}`, data, options);
  }

  putAdmin(endpoint: string, data, options?): Observable<any> {
    return this.http.put(`${this.apiUrlAdmin}/${endpoint}`, data, options);
  }

  deleteAdmin(endpoint: string, options?): Observable<any> {
    return this.http.delete(`${this.apiUrlAdmin}/${endpoint}`, options);
  }

  /**
   * 
   * Customer users from Client App
   * 
   */

  getApp(endpoint: string, options?): Observable<any> {
    return this.http.get(`${this.apiUrlApp}/${endpoint}`, options);
  }

  postApp(endpoint: string, data, options?): Observable<any> {
    return this.http.post(`${this.apiUrlApp}/${endpoint}`, data, options);
  }

  putApp(endpoint: string, data, options?): Observable<any> {
    return this.http.put(`${this.apiUrlApp}/${endpoint}`, data, options);
  }

  deleteApp(endpoint: string, options?): Observable<any> {
    return this.http.delete(`${this.apiUrlApp}/${endpoint}`, options);
  }
}
